import { render, staticRenderFns } from "./NotifiedRolesIndicator.vue?vue&type=template&id=764c0b58&scoped=true&"
import script from "./NotifiedRolesIndicator.vue?vue&type=script&lang=ts&"
export * from "./NotifiedRolesIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./NotifiedRolesIndicator.vue?vue&type=style&index=0&id=764c0b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764c0b58",
  null
  
)

export default component.exports